
export const GET_QUICKSIGHT_EMBED_URL_INITIAL_STATE = {
    fetching: false,
    embedUrl: '',
    failed: false,
};

export const getQuicksightEmbedUrlInitialState = initialState =>{
    return initialState;
};

export const getQuicksightEmbedUrlReducer = (state, action) => {
    switch (action.type){
        case "BEGIN":
            return {
                ...state,
                fetching: true,
                failed: false

            }
        case "SUCCESS":
            return {
                ...state,
                embedUrl : action.payload?.embedUrl,
                fetching: false,
                // A completed response without an embed URL is surfaced as a failure
                // rather than an infinite loading state.
                failed: !action.payload?.embedUrl
            }
        case "FAILURE":
            return {
                ...state,
                fetching: false,
                failed: true

            }
        default:
            return state
    }
};


